
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Explore the best of North Goa with unforgettable sightseeing experiences. From stunning beaches to historical landmarks, discover everything this vibrant region has to offer.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the top sightseeing spots in North Goa. From beautiful beaches to historic sites, explore the vibrant culture and scenic landscapes of this amazing region.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy the best of North Goa sightseeing. Visit stunning beaches, historic landmarks, and vibrant local spots for a truly unforgettable experience.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'places to visit in north goa, best places to visit in north goa, hidden places to visit in north goa, places to visit in north goa other than beaches, places to visit in north goa for couples, places to visit in north goa with family, places to visit in north goa in 3 days, top 10 places to visit in north goa, places to visit in north goa in 2 days',
        },
       
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Destinations",
      text: "Discover breathtaking views and hidden gems with the best sightseeing spots in Goa!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether you're an adventure lover or prefer a relaxed tour, there's something for everyone!",
    },
    {
      title: "Local Guides",
      text: "Our experienced guides will take you to the top attractions and share fascinating insights.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect sightseeing tour effortlessly through the Goa App at great rates!",
    },
  ],

    
      title: 'Places to Visit in North Goa - Places to Visit in North Goa Other Than Beaches ',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/places-to-visit-in-north-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/places-to-visit-in-north-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/places-to-visit-in-north-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Places to Visit in North Goa - Book @ ₹399 Flat 33% Off",
  "description": "Experience the best sightseeing in North Goa, where stunning landscapes, vibrant culture, and iconic landmarks come together for an unforgettable journey filled with picturesque moments.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "399",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/places-to-visit-in-north-goa",
        "url": "https://www.goa.app/places-to-visit-in-north-goa",
        "name": "Places to Visit in North Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-06T11%3A19%3A11.594Zcalangute-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=aLbV8IRTO%2BLIOSxzcPxPGH3xLxu7wN919SG%2Bjf7EnNeUfMtKtJmTfBfR73%2FK0RsLI9fxSQnejdcbaiV5iQtmezeZ5n7rAFYBzttOmvLepXR7TGRsC241uNPO%2FgM85HYhguUtwiaSgK17lmnDdPHCW%2Fd1lZa0lqu3ZTA1hAi3XH724CO7cJeuwfxDyLCrASe0LPFcw4l8WpAzSAN1rz3V8Ybr2pVvVDfkPnr29Kza2lPMYrz6tfPJdJatUroKew1zmUm%2BDlCAuJM4MMpMkfPX6ilOtPSkdNnLaQwHS2gXLNA2BJwNVuyY0EENTrGy6K7ptMlcrKtMxQB7yst2KVyeWw%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "North Goa sightseeing Tour offers breathtaking views of stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for travelers looking to explore beautiful sunsets, historic sites like Aguada Fort, and lush greenery, creating unforgettable memories along the way.",
        "breadcrumb": {
            "@id": "https://www.goa.app/places-to-visit-in-north-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/places-to-visit-in-north-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What are the must-visit places in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some must-visit places in North Goa include Calangute Beach, Baga Beach, Aguada Fort, and Sinquerim Beach."
      }
    },
    {
      "@type": "Question",
      "name": "What types of attractions can I find in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In North Goa, you'll find a mix of attractions, including beautiful beaches, historic forts, vibrant markets, and scenic viewpoints."
      }
    },
    {
      "@type": "Question",
      "name": "Are there any family-friendly places to visit in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many family-friendly places include Fort Aguada, the Butterfly Conservatory, and various beaches like Candolim and Anjuna."
      }
    },
    {
      "@type": "Question",
      "name": "Can I explore North Goa's attractions in a day?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many attractions in North Goa are close to each other, making it possible to explore several places in a day."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time to visit places in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time to visit North Goa is from November to February when the weather is pleasant for sightseeing."
      }
    },
    {
      "@type": "Question",
      "name": "Are there any entry fees for visiting certain places in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some attractions, like forts and museums, may have entry fees, while many beaches are free to access."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need a guide to explore places in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "While a guide can enhance your experience, it's not necessary; many places are easily accessible on your own."
      }
    },
    {
      "@type": "Question",
      "name": "Can I visit less-known places in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! Exploring less-known spots can provide a unique and memorable experience away from the crowds."
      }
    },
    {
      "@type": "Question",
      "name": "What should I pack when visiting North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's recommended to pack sunscreen, comfortable footwear, swimwear, and a camera to capture the beautiful sights."
      }
    },
    {
      "@type": "Question",
      "name": "How can I find places to visit in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can find places to visit in North Goa through online travel guides, blogs, and local tourism websites."
      }
    }
        ]
      }
    ]
  };
},


};



  